import authAPI from '../../_api/auth';
import {
  SET_AUTH_USER_DATA,
  INCREMENT_APHORISMS_COUNT, DECREMENT_APHORISMS_COUNT,
  DECREMENT_FAVORITES_COUNT, INCREMENT_CART_COUNT,
  DECREMENT_NOTIFICATIONS_COUNT, DECREMENT_COMMENTS_COUNT,
  INCREMENT_PLAYLISTS_COUNT, DECREMENT_PLAYLISTS_COUNT,
} from '../constants/auth';
import { setShopCountersData } from './shop';

export const setAuthUserData = (data) => ({ type: SET_AUTH_USER_DATA, data });

export const getAuthUserData = () => (dispatch) => {
  return authAPI.getMe().then(response => {
    if (response) {
      let shopData = {}
      Object.entries(response).forEach(([key, value]) => {
        if (['arrangements_count', 'lessons_count', 'arrangements_moder_count', 'lessons_moder_count'].includes(key)){
          shopData[key] = value;
          delete response[key];
        }
      });
      dispatch(setAuthUserData(response));
      dispatch(setShopCountersData(shopData));
    }
  });
};

export const incrementAphorismsCount = () => ({type: INCREMENT_APHORISMS_COUNT});
export const decrementAphorismsCount = () => ({type: DECREMENT_APHORISMS_COUNT});

export const decrementFavoritesCount = (value) => ({type: DECREMENT_FAVORITES_COUNT, value});
export const incrementCartCount = (value) => ({type: INCREMENT_CART_COUNT, value});

export const decrementNotificationsCount = (value) => ({type: DECREMENT_NOTIFICATIONS_COUNT, value});

export const decrementCommentsCount = (value) => ({type: DECREMENT_COMMENTS_COUNT, value});

export const incrementPlaylistsCount = () => ({type: INCREMENT_PLAYLISTS_COUNT});
export const decrementPlaylistsCount = () => ({type: DECREMENT_PLAYLISTS_COUNT});

export const getCurrentUserBalance = () => (dispatch) => {
  return authAPI.getMyBalance().then(response => {
    if (response) {
      dispatch(setAuthUserData(response));
    }
  });
};



